<script lang="ts">
    import Desktop from "$lib/layout/Desktop.svelte";
    import Mobile from "$lib/layout/Mobile.svelte";

    let mobile = document.body.clientWidth < 800;
</script>

<!----------------------------------------------------------------------------->

{#if mobile}
    <Mobile>
        <slot />
    </Mobile>
{:else}
    <Desktop>
        <slot />
    </Desktop>
{/if}

<!--<Mobile>-->
<!--    <slot />-->
<!--</Mobile>-->

<!----------------------------------------------------------------------------->

<style></style>
